require("packs/bookmarks");
require("packs/user_profile_popup");
require("packs/comment_actions");
require("packs/comment_events");
require("packs/reactions");
require("packs/original_image");
import "stylesheets/topic";
import { setRedactorReply, setRedactorAdmin } from "packs/redactor_main";
import { fetchAPI } from "packs/api";
import { initializeStaticBannerClicks } from 'shared/banner_utils';

function commentEditorFocused() {
  let active = document.activeElement;
  return !!(active && active.closest && active.closest(".redactor-box"));
}

// Any rendered redactor editor — the comment box or a reply/edit one. `.redactor-box`
// is created on demand (0–few) and only exists while a reply editor is open, so the
// sticky footer hides only while composing — not when a collapsed reply box is merely
// on screen. No geometry read, so no forced layout on tap/scroll (the previous version
// scanned every .reply-box-closed with getBoundingClientRect() on each mobile
// focusin/scroll/click — the mobile INP regression).
function commentEditorVisible() {
  return Array.prototype.some.call(
    document.querySelectorAll(".redactor-box"),
    function (box) {
      return box.offsetParent !== null;
    }
  );
}

function updateStickyBars() {
  let sticky_header = document.getElementById("header-sticky-scroll");
  let sticky_footer = document.getElementById("footer-sticky-scroll");
  let footerShow = document.getElementById("footer-show");
  let scrollTop = document.getElementById("scroll-top");

  // Use half viewport height for consistency with footer button behavior
  const halfViewportHeight = window.innerHeight / 2;
  const scrolled = window.pageYOffset > halfViewportHeight;

  if (scrolled) {
    if (sticky_header) sticky_header.classList.remove("hidden");
    checkBookmark();
  } else if (sticky_header) {
    sticky_header.classList.add("hidden");
  }

  if (window.innerWidth >= 768) return;

  const showFooter =
    scrolled && !commentEditorVisible() && !commentEditorFocused();
  if (sticky_footer) sticky_footer.classList.toggle("hidden", !showFooter);
  // Raise floating buttons above the sticky footer bar
  if (footerShow) footerShow.style.bottom = showFooter ? "55px" : "";
  if (scrollTop) scrollTop.style.bottom = showFooter ? "55px" : "";
}

// Scroll fires many times per frame; coalesce to one updateStickyBars per repaint.
let stickyBarsScrollScheduled = false;
window.addEventListener(
  "scroll",
  function () {
    if (stickyBarsScrollScheduled) return;
    stickyBarsScrollScheduled = true;
    requestAnimationFrame(function () {
      updateStickyBars();
      stickyBarsScrollScheduled = false;
    });
  },
  { passive: true }
);
document.addEventListener("focusin", updateStickyBars);
document.addEventListener("focusout", function () {
  setTimeout(updateStickyBars, 0);
});
// Editors open/close on click and take 300ms to animate away
document.addEventListener("click", function () {
  setTimeout(updateStickyBars, 320);
});
function checkBookmark() {
  let currentUserMonitoring = document.getElementById("CurrentUserMonitoring");
  let mute_check = document.getElementById("CurrentUserMutedThread"); //.dataset.alreadymuted;
  if (
    currentUserMonitoring &&
    currentUserMonitoring.dataset.alreadymonitoring != null &&
    (mute_check == null || mute_check == undefined)
  ) {
    if (
      currentUserMonitoring &&
      currentUserMonitoring.dataset.alreadymonitoring === "1"
    ) {
      document
        .querySelectorAll(".bookmark-or-mute")
        .forEach(function (bookmark) {
          bookmark.classList.add("hidden");
        });
      document
        .querySelectorAll(".remove-bookmark")
        .forEach(function (removeBookmark) {
          removeBookmark.classList.remove("hidden");
        });
    } else {
      document
        .querySelectorAll(".bookmark-or-mute")
        .forEach(function (bookmark) {
          bookmark.classList.remove("hidden");
        });
      document
        .querySelectorAll(".remove-bookmark")
        .forEach(function (removeBookmark) {
          removeBookmark.classList.add("hidden");
        });
    }
  } else if (mute_check != null || mute_check != undefined) {
    document.querySelectorAll(".unmute-post").forEach(function (unmute) {
      unmute.classList.remove("hidden");
    });
  } else {
    if (document.getElementById("currentUserPresent")) {
      return;
    }
    document.getElementById("nonloginbookmarkicon").classList.remove("hidden");
    document.getElementById("nonloginbookmarkiconsticky").classList.remove("hidden");
  }
}
checkBookmark();
let shareIcon = document.getElementById("shareIcon");
let shareIconSticky = document.getElementById("shareIconSticky");
let popupMenudrop = document.getElementById("popupMenudrop");
let popupMenudropSticky = document.getElementById("popupMenudropSticky");
let togglePopupMenu = () => {
  if (popupMenudrop.classList.contains("hidden")) {
    showDropdownAnimated(popupMenudrop);
  } else {
    hideDropdownAnimated(popupMenudrop);
  }
};
let togglePopupMenuSticky = () => {
  if (popupMenudropSticky.classList.contains("hidden")) {
    showDropdownAnimated(popupMenudropSticky);
  } else {
    hideDropdownAnimated(popupMenudropSticky);
  }
};
// Event listener for share icon click
if (shareIcon) {
  shareIcon.addEventListener("click", togglePopupMenu);
  let closeIconshare = document.querySelector(".close-div-1");
  // Event listener for close icon click
  closeIconshare.addEventListener("click", () => {
    hideDropdownAnimated(popupMenudrop);
  });
}
if (shareIconSticky) {
  shareIconSticky.addEventListener("click", togglePopupMenuSticky);
  let closeIconshare = document.querySelector(".close-div-2");
  // Event listener for close icon click
  closeIconshare.addEventListener("click", () => {
    hideDropdownAnimated(popupMenudropSticky);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  window.setRedactorReply = setRedactorReply;
  window.setRedactorAdmin = setRedactorAdmin;
  initializeStaticBannerClicks();
  setTopComments();

  let share_options = document.querySelectorAll(".share-options");

  share_options.forEach(function (share_option) {
    share_option.addEventListener("click", function () {
      let option_list = this.parentNode.querySelector(".share-option-list");
      if (this.classList.contains("open")) {
        this.parentNode
          .querySelector(".share-icon")
          .classList.remove("rotate-180");
        slideUpContent(option_list);
      } else {
        this.parentNode
          .querySelector(".share-icon")
          .classList.add("rotate-180");
        slideDownContent(option_list);
      }
      this.classList.toggle("open");
    });
  });

  //Scroll to comment section
  let scroll_to_comments = document.querySelectorAll(".scroll-to-comments");
  if (scroll_to_comments) {
    scroll_to_comments.forEach(function (scroll_to_comment) {
      scroll_to_comment.addEventListener("click", function () {
        document.getElementById("comments").scrollIntoView();
        let reply_box = document.querySelector(".reply-box-open-close");
        if (!reply_box) {
          // Guest: reply box is wrapped in the login trigger
          let login_box = document.querySelector(".reply-box-closed");
          if (login_box) login_box.click();
          return;
        }
        // Already open: focus synchronously so the mobile keyboard reopens
        let editable = reply_box.querySelector(
          '.custom-redactor-reply[contenteditable="true"]'
        );
        if (editable) {
          editable.focus();
        } else {
          reply_box.click();
        }
      });
    });
  }

  // Show second comment section
  var postsList = document.getElementById("comments");
  var secondCommentContainer = document.getElementById(
    "second-comment-container"
  );

  if (postsList && secondCommentContainer) {
    var postsListHeight = postsList.offsetHeight;
    var viewportHeight = window.innerHeight;

    // Show the second-comment-container if posts_list height is greater than viewport height
    if (postsListHeight > viewportHeight) {
      secondCommentContainer.style.display = "block";
    } else {
      secondCommentContainer.style.display = "none";
    }
  }
});

// Comment search helpers
function getSearchInputs() {
  return ["desktop", "mobile"].map(view => ({
    input: document.getElementById("comment-search-" + view),
    closeIcon: document.getElementById("search-close-" + view),
    mobile: view === "mobile"
  }));
}

function expandSearchInput(input, closeIcon, mobile) {
  if (input) {
    input.style.width = mobile ? "100%" : "200px";
    input.style.paddingRight = "28px";
  }
  if (closeIcon) closeIcon.classList.remove("hidden");
}

function collapseSearchInput(input, closeIcon) {
  if (input) {
    input.style.width = "";
    input.style.paddingRight = "";
  }
  if (closeIcon) closeIcon.classList.add("hidden");
}

// To clear search comment empty state
function clearSearchState() {
  let currentsearchURL = window.location.href;
  if (currentsearchURL.includes("?")) {
    let updatedURL = currentsearchURL.split("?")[0];
    window.location.href = updatedURL + "#comments";
  }
}

// Event listener for '.clear-search' elements
document.querySelectorAll(".clear-search").forEach(function (el) {
  el.addEventListener("click", clearSearchState);
});

// Scroll into view if query exists, and set up search bar event handlers
document.addEventListener("DOMContentLoaded", function () {
  let queryParam = new URLSearchParams(window.location.search).get("query");

  getSearchInputs().forEach(({ input, closeIcon, mobile }) => {
    // Expand search bars if there's an active query
    if (queryParam && input) {
      expandSearchInput(input, closeIcon, mobile);
    }

    if (!input) return;

    input.addEventListener("keyup", function () {
      if (input.value.length > 0) {
        expandSearchInput(input, closeIcon, mobile);
      } else {
        closeIcon.classList.add("hidden");
      }
    });

    input.addEventListener("blur", function () {
      if (input.value.length > 0) {
        expandSearchInput(input, closeIcon, mobile);
      } else {
        collapseSearchInput(input, closeIcon);
      }
    });

    input.addEventListener("focus", function () {
      if (input.value.length > 0) {
        closeIcon.classList.remove("hidden");
      }
    });

    if (closeIcon) {
      closeIcon.addEventListener("click", function () {
        input.value = "";
        collapseSearchInput(input, closeIcon);
        clearSearchState();
      });
    }
  });

  // Scroll to comments if query is active
  if (queryParam) {
    let element = document.getElementById("comments");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
});

let dropdownButton = document.getElementById("dropdownButton");
let dropdownContent = document.getElementById("dropdown");
if (dropdownButton) {
  dropdownContent.addEventListener("click", () => {
    document.getElementById("dropdown").classList.toggle("hidden");
  });
}


document.querySelectorAll(".loading-wrapper").forEach(el => el.remove());
document.querySelectorAll(".poll-wrapper").forEach(el => el.style.display = "block");

document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll(".pp-radio").forEach((option) => {
    option.addEventListener("click", function (event) {
      submitPoll(this);
    });
  });
});

function submitPoll(element) {
  const formContainer = document.getElementById("discussion_poll_form");
  const actionUrl = formContainer.getAttribute("data-action-url");
  const csrfToken = formContainer.getAttribute("data-csrf-token");
  const questionId = element.getAttribute("data-question-id");
  const answerId = element.getAttribute("data-answer-id");
  const expired = formContainer.getAttribute("data-poll-expired");

  if (expired == "true") {
    return;
  }

  fetchAPI("/responses", "POST", { response: { question_id: questionId, answer_id: answerId } }, "script");
}

window.submitPoll = submitPoll;

function showModalAndPreventDefault(event, modalId, actionType) {
  event.preventDefault();
  ShowModalPopup(modalId, actionType, "true");
}

function sortComments(url, type) {
  window.location.href = url + "?sort_by=" + type + "#comments";
}

document.addEventListener("DOMContentLoaded", () => {
  var currentUserIdElement = document.getElementById("CurrentUserID");
  if (currentUserIdElement != null) {
    var postReactedElement = document.getElementById("PostReacted");
    if (postReactedElement != null) {
      var reactionsGiven = JSON.parse(
        postReactedElement.getAttribute("data-reactions-given")
      );
      reactionsGiven.forEach((reaction) => {
        document.querySelectorAll(".voting_status_" + reaction.post_id).forEach(el => {
          el.innerHTML = `
              <img alt="${reaction.name}" loading="lazy" src="${reaction.reaction_url}" height="20" width="20">
              <span class="text-secondary-text-light dark:text-secondary-text-dark ml-2 md:text-sm text-xs gtm-post-like">${reaction.name}</span>
            `;
        });
      });
    }
  }
});

window.addEventListener("load", () => {
  if (window.location.hash) {
    const targetId = window.location.hash.substring(1);
    const targetElement = document.getElementById(`${targetId}_new`);
    if (targetElement) {
      const isDarkTheme = document.documentElement.classList.contains("dark");
      const highlightColor = isDarkTheme ? "var(--color-primary-text-light)" : "var(--color-highlight-bg)";

      const scrollToTarget = () => {
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY - 140;
        window.scrollTo({ top: elementPosition, behavior: "smooth" });
      };

      // Initial scroll
      setTimeout(scrollToTarget, 100);
      // Correction scroll after lazy images settle
      setTimeout(scrollToTarget, 1500);

      // Highlight after correction scroll
      setTimeout(() => {
        targetElement.style.backgroundColor = highlightColor;
        setTimeout(() => {
          targetElement.style.transition = "background-color 4s ease";
          targetElement.style.backgroundColor = "transparent";
        }, 100);
        setTimeout(() => {
          targetElement.style.backgroundColor = "";
          targetElement.style.transition = "";
        }, 4100);
      }, 1500);
    }
  }
});



window.sortComments = sortComments;

// Self-delete countdown timer
(function() {
  var inlineTimer = document.getElementById("self-delete-inline-timer");
  if (inlineTimer) {
    updateSelfDeleteInlineTimer(inlineTimer, inlineTimer.dataset.topicCreatedAt);
  }

  function selfDeleteTimeRemaining(topicCreatedAt) {
    var createdAt = new Date(topicCreatedAt);
    var now = new Date();
    return createdAt.getTime() + 5 * 60 * 1000 - now.getTime();
  }

  function formatSelfDeleteTime(ms) {
    if (ms <= 0) return "00:00";
    var minutes = Math.floor((ms / 1000) / 60);
    var seconds = Math.floor((ms / 1000) % 60);
    return (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
  }

  function updateSelfDeleteInlineTimer(el, createdAt) {
    var remaining = selfDeleteTimeRemaining(createdAt);
    if (remaining <= 0) {
      var section = document.getElementById("self-delete-topic-section");
      if (section) section.remove();
      var modal = document.getElementById("self-delete-modal");
      if (modal) modal.remove();
      return;
    }
    el.textContent = formatSelfDeleteTime(remaining);
    setTimeout(function() { updateSelfDeleteInlineTimer(el, createdAt); }, 1000);
  }

  function updateSelfDeleteModalTimer(el, createdAt) {
    var remaining = selfDeleteTimeRemaining(createdAt);
    if (remaining <= 0) {
      el.textContent = "00:00";
      var btn = document.getElementById("self-delete-confirm-btn");
      if (btn) {
        btn.disabled = true;
        btn.classList.add("opacity-50", "cursor-not-allowed");
        btn.classList.remove("cursor-pointer");
      }
      return;
    }
    el.textContent = formatSelfDeleteTime(remaining);
    setTimeout(function() { updateSelfDeleteModalTimer(el, createdAt); }, 1000);
  }

  window.openSelfDeleteModal = function() {
    var modal = document.getElementById("self-delete-modal");
    modal.classList.remove("hidden");
    modal.classList.add("flex");
    var modalTimer = document.getElementById("self-delete-modal-timer");
    if (modalTimer) {
      updateSelfDeleteModalTimer(modalTimer, modalTimer.dataset.topicCreatedAt);
    }
  };

  window.closeSelfDeleteModal = function() {
    var modal = document.getElementById("self-delete-modal");
    modal.classList.add("hidden");
    modal.classList.remove("flex");
  };
})();

// Follow/unfollow author button toggle
document.addEventListener('ajax:success', function(e) {
  var btn = e.target.closest('.follow-author-btn');
  if (!btn) return;
  var isFollowing = btn.dataset.action === 'follow';
  btn.dataset.action = isFollowing ? 'unfollow' : 'follow';
  btn.textContent = isFollowing ? btn.dataset.followingText : btn.dataset.followText;
  btn.href = isFollowing ? btn.dataset.unfollowUrl : btn.dataset.followUrl;
});

// Popular sort spotlight — shows once when user scrolls to comment sort dropdown
(function () {
  var HINT_KEY = "popular_sort_spotlight";
  var COOKIE_NAME = "hint_" + HINT_KEY;

  // Cookie is the local cache for both guests and logged-in users. For logged-in
  // users we also persist server-side so the hint stays dismissed across devices.
  function markHintSeen() {
    Cookies.set(COOKIE_NAME, "1", { expires: 365, path: '/' });
    var loggedIn = document.body && document.body.getAttribute("data-gtm-logged-in") === "true";
    if (!loggedIn) return;
    fetchAPI("/hints/" + HINT_KEY + "/seen", "POST", {}, "text").catch(function () {});
  }

  if (Cookies.get(COOKIE_NAME)) return;

  var spotlight = document.getElementById("popular-sort-spotlight");
  var circle = document.getElementById("popular-sort-circle");
  var innerRing = document.getElementById("popular-sort-inner-ring");
  var content = document.getElementById("popular-sort-circle-content");
  var orderBtn = document.getElementById("comment-order-button");
  if (!spotlight || !circle || !innerRing || !content || !orderBtn) return;

  var shown = false;
  var isMobile = window.innerWidth < 768;
  var dismissTimer = null;
  var scrollSync = null;
  // Store original button inner HTML so we can restore it on dismiss
  var originalBtnHTML = orderBtn.innerHTML;

  // Non-trapping dismissal: the spotlight is a visual highlight only and never
  // blocks the page. Scrolling works normally and does NOT dismiss it — the
  // highlight simply moves with the page content. On desktop the circle is
  // position:absolute, so it scrolls away on its own. On mobile the overlay is
  // position:fixed; a transform on the fixed container makes its fixed children
  // resolve to it, so translating it by the scroll delta (see scrollSync in
  // showMobileSpotlight) keeps the highlight glued to the page. A click anywhere
  // closes it (and passes through, since we never preventDefault); a safety timer
  // closes it if the user does nothing. Both route through hideSpotlight ->
  // markHintSeen.
  var AUTO_DISMISS_MS = 10000;
  function onDismiss(e) {
    // The spotlight's own buttons handle themselves — don't close underneath them
    if (e && e.target && e.target.closest && e.target.closest("#popular-sort-circle-content")) return;
    hideSpotlight(false);
  }
  function armDismiss() {
    dismissTimer = setTimeout(function () { hideSpotlight(false); }, AUTO_DISMISS_MS);
    document.addEventListener("click", onDismiss, true);
  }
  function disarmDismiss() {
    if (dismissTimer) { clearTimeout(dismissTimer); dismissTimer = null; }
    document.removeEventListener("click", onDismiss, true);
    if (scrollSync) { window.removeEventListener("scroll", scrollSync, { passive: true }); scrollSync = null; }
  }
  var popularLabel = orderBtn.dataset.popularLabel || "Popular Comments";

  // Desktop config
  var CIRCLE_SIZE = 714;
  var RING_SIZE = 160;
  var HOLE_RADIUS = RING_SIZE / 2;
  var RING_OFFSET_X = -150; // negative = left of center
  var RING_OFFSET_Y = 0;    // vertically centered

  function swapToPopularWithDelay() {
    var svgEl = orderBtn.querySelector("svg");
    if (!svgEl) return;
    var svgMarkup = svgEl.outerHTML;
    orderBtn.style.overflow = "hidden";

    // Wrap current text for slide-out
    var currentHTML = orderBtn.innerHTML;
    orderBtn.innerHTML = '<span style="display:block;transition:transform 0.35s ease;">' + currentHTML + '</span>';
    var oldSpan = orderBtn.querySelector("span");

    setTimeout(function () {
      // Step 1: Slide old text up and out
      oldSpan.style.transform = "translateY(-100%)";

      setTimeout(function () {
        // Step 2: Replace with new text positioned below, then slide up
        orderBtn.innerHTML = '<span style="display:block;transition:transform 0.35s ease;transform:translateY(100%);">' + popularLabel + " " + svgMarkup + '</span>';
        var newSpan = orderBtn.querySelector("span");

        requestAnimationFrame(function () {
          newSpan.style.transform = "translateY(0)";

          // Just remove overflow after animation — don't replace innerHTML
          setTimeout(function () {
            orderBtn.style.overflow = "";
          }, 400);
        });
      }, 350);
    }, 1500);
  }

  if (isMobile) {
    // Scale ring to fit the "Sorted by" text
    var sortedByLabel = orderBtn.parentElement;
    var neededWidth = sortedByLabel ? sortedByLabel.offsetWidth : 200;
    RING_SIZE = Math.max(neededWidth + 40, 160);
    HOLE_RADIUS = RING_SIZE / 2;
  }

  function showSpotlight() {
    if (shown) return;
    if (isMobile) return; // Mobile uses showMobileSpotlight

    shown = true;
    markHintSeen();
    spotlight.classList.remove("hidden");
    armDismiss();

    // After a delay, animate the dropdown text to "Popular"
    swapToPopularWithDelay();

    {
      // Desktop: position circle, ring, and content
      var btnCx = orderBtn.offsetLeft + orderBtn.offsetWidth / 2;
      var btnCy = orderBtn.offsetTop + orderBtn.offsetHeight / 2;

      var outerCx = btnCx - RING_OFFSET_X;
      var outerCy = btnCy - RING_OFFSET_Y;

      var holeCxLocal = CIRCLE_SIZE / 2 + RING_OFFSET_X;
      var holeCyLocal = CIRCLE_SIZE / 2 + RING_OFFSET_Y;

      circle.style.setProperty("--circle-size", CIRCLE_SIZE + "px");
      circle.style.setProperty("--hole-cx", holeCxLocal + "px");
      circle.style.setProperty("--hole-cy", holeCyLocal + "px");
      circle.style.setProperty("--hole-r", HOLE_RADIUS + "px");
      // Use background radial-gradient (transparent hole + rgba dim).
      // Mask-image with var() is buggy in Safari; this is the cross-browser fix.
      // If the gradient string fails to parse for any reason, the CSS fallback
      // `background: rgba(20,20,20,0.92)` keeps a solid dim visible.
      var dimGradient = "radial-gradient(circle at " + holeCxLocal + "px " + holeCyLocal + "px, rgba(0,0,0,0) 0, rgba(0,0,0,0) " + HOLE_RADIUS + "px, rgba(20,20,20,0.92) " + HOLE_RADIUS + "px)";
      circle.style.background = dimGradient;
      circle.style.backgroundColor = "transparent";
      circle.style.webkitMaskImage = "";
      circle.style.maskImage = "";
      circle.style.left = outerCx + "px";
      circle.style.top = outerCy + "px";
      var originX = (holeCxLocal / CIRCLE_SIZE * 100).toFixed(1);
      var originY = (holeCyLocal / CIRCLE_SIZE * 100).toFixed(1);
      circle.style.transformOrigin = originX + "% " + originY + "%";

      innerRing.style.setProperty("--ring-size", RING_SIZE + "px");
      innerRing.style.left = btnCx + "px";
      innerRing.style.top = btnCy + "px";

      content.style.left = (btnCx + RING_SIZE / 2 + 75) + "px";
      content.style.top = btnCy + "px";
      content.style.transform = "translateY(-50%)";

      requestAnimationFrame(function () {
        circle.classList.add("active");
        innerRing.classList.add("active");
        content.classList.add("active");
      });
    }
  }

  // Mobile: uses pre-calculated coordinates so hole always matches scroll position
  function showMobileSpotlight() {
    if (shown) return;
    shown = true;
    markHintSeen();
    spotlight.classList.remove("hidden");
    armDismiss();

    // After a delay, animate the dropdown text to "Popular"
    swapToPopularWithDelay();

    // Visual-only overlay: no scroll lock, no chrome hiding — the page stays usable
    spotlight.classList.add("mobile-active");

    // Keep the fixed overlay moving with the page as the user scrolls. The
    // transform below makes the fixed container the containing block for its
    // fixed children, so translating it by the scroll delta shifts the whole
    // highlight — the coordinates computed below stay valid, no re-layout needed.
    var startScrollY = window.pageYOffset;
    spotlight.style.transform = "translateY(0px)";
    scrollSync = function () {
      spotlight.style.transform = "translateY(" + (startScrollY - window.pageYOffset) + "px)";
    };
    window.addEventListener("scroll", scrollSync, { passive: true });

    // Backdrop covers bottom 80% of viewport
    var backdropH = window.innerHeight * 0.8;
    var backdropTop = window.innerHeight - backdropH;

    // Read the actual button position NOW (after scroll snap has settled)
    var actualRect = orderBtn.getBoundingClientRect();
    var actualBtnCx = actualRect.left + actualRect.width / 2;
    var actualBtnCy = actualRect.top + actualRect.height / 2;

    // Circle is 250vw wide, centered. Its left edge is at (50vw - 125vw)
    var circleWidth = window.innerWidth * 2.5;
    var circleLeft = (window.innerWidth / 2) - (circleWidth / 2);

    // Hole position relative to the circle's top-left
    var holeCxLocal = actualBtnCx - circleLeft;
    var holeCyLocal = actualBtnCy - backdropTop;

    circle.style.setProperty("--hole-cx", holeCxLocal + "px");
    circle.style.setProperty("--hole-cy", holeCyLocal + "px");
    circle.style.setProperty("--hole-r", HOLE_RADIUS + "px");
    circle.style.setProperty("--backdrop-top", backdropTop + "px");
    var dimGradient = "radial-gradient(circle at " + holeCxLocal + "px " + holeCyLocal + "px, rgba(0,0,0,0) 0, rgba(0,0,0,0) " + HOLE_RADIUS + "px, rgba(20,20,20,0.92) " + HOLE_RADIUS + "px)";
    circle.style.background = dimGradient;
    circle.style.backgroundColor = "transparent";
    circle.style.webkitMaskImage = "";
    circle.style.maskImage = "";
    circle.style.transformOrigin = holeCxLocal + "px " + holeCyLocal + "px";

    innerRing.style.setProperty("--ring-size", RING_SIZE + "px");
    innerRing.style.left = actualBtnCx + "px";
    innerRing.style.top = actualBtnCy + "px";

    content.style.left = "50%";
    content.style.top = (actualBtnCy - RING_SIZE / 2 - 60) + "px";
    content.style.transform = "translate(-50%, -100%)";

    requestAnimationFrame(function () {
      circle.classList.add("active");
      innerRing.classList.add("active");
      content.classList.add("active");
    });
  }

  function hideSpotlight(keepPopularLabel) {
    disarmDismiss();
    markHintSeen();
    // Restore original dropdown text unless user chose "Try Popular"
    if (!keepPopularLabel) {
      orderBtn.innerHTML = originalBtnHTML;
    }
    circle.classList.remove("active");
    innerRing.classList.remove("active");
    content.classList.remove("active");
    if (isMobile) {
      spotlight.classList.remove("mobile-active");
    }
    setTimeout(function () {
      spotlight.classList.add("hidden");
      spotlight.style.transform = "";
    }, 550);
  }

  // Scroll observer — only trigger when dropdown scrolls INTO view (not if already visible)
  var wasVisible = false;
  var firstCheck = true;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (firstCheck) {
          // On first callback, just record current state — don't trigger
          firstCheck = false;
          wasVisible = entry.isIntersecting;
          return;
        }
        if (entry.isIntersecting && !wasVisible) {
          wasVisible = true;
          observer.disconnect();
          if (isMobile) {
            // No scroll lock, no viewport hijack — the ring frames the dropdown
            // wherever it currently sits (hole is computed live from its rect).
            requestAnimationFrame(showMobileSpotlight);
          } else {
            setTimeout(showSpotlight, 400);
          }
        }
        wasVisible = entry.isIntersecting;
      });
    },
    { threshold: 0.8 }
  );
  observer.observe(orderBtn);

  // "Try Popular Sorting" button
  var tryBtn = document.getElementById("popular-sort-try-btn");
  if (tryBtn) {
    tryBtn.addEventListener("click", function () {
      hideSpotlight(true);
      var path = orderBtn.dataset.sortPath;
      if (path) {
        sortComments(path, "popular");
      }
    });
  }

  // "Maybe Later" button
  var laterBtn = document.getElementById("popular-sort-later-btn");
  if (laterBtn) {
    laterBtn.addEventListener("click", function () { hideSpotlight(false); });
  }


})();

function setTopComments() {
  let topComments = document.getElementById("top-comments-open-close");
  let topCommentsContent = document.getElementById("top-comments-content");
  let openEye = document.getElementById("open-eye");
  let closeEye = document.getElementById("close-eye");
  if (topComments) {
    topComments.addEventListener("click", function () {
      if (topCommentsContent.classList.contains("hidden")) {
        this.classList.add("border-b");
        openEye.classList.remove("hidden");
        closeEye.classList.add("hidden");
        slideDownContent(topCommentsContent);
      } else {
        slideUpContent(topCommentsContent);
        setTimeout(() => {
          openEye.classList.add("hidden");
          closeEye.classList.remove("hidden");
          this.classList.remove("border-b");
        }, 500);
      }
    });
  }
}
